import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AppleLoginOnly = () => {
  const navigate = useNavigate();

  // Check if we're returning from Apple authentication
  useEffect(() => {
    // Check if we have tokens in the URL or localStorage
    const urlParams = new URLSearchParams(window.location.search);
    const appleToken = urlParams.get('apple_token') || localStorage.getItem('apple_token');
    const appleTokenExpiresAt = urlParams.get('apple_token_expires_at') || localStorage.getItem('apple_token_expires_at');
    
    if (appleToken && appleTokenExpiresAt) {
      // Store tokens in localStorage if they're in the URL
      if (urlParams.get('apple_token')) {
        localStorage.setItem('apple_token', appleToken);
        localStorage.setItem('apple_token_expires_at', appleTokenExpiresAt);
      }
      
      // Redirect to home page
      window.location.href = 'https://eztiptap.com';
    }
  }, []);

  const handleAppleLogin = () => {
    // Apple Sign In configuration
    const clientId = 'com.taptipgo';
    
    // Get API URL with fallback for local development
    const apiUrl = process.env.REACT_APP_DJANGO_API_URL;
    
    // Redirect to our apple_login_no_account endpoint first
    const redirectUri = `${apiUrl}/api/apple_login_no_account/`;
    const responseType = 'code id_token';
    const responseMode = 'form_post'; // Required when requesting name or email scope
    const scope = 'email name';
    
    // Construct the Apple Sign In URL with correct parameters
    const appleAuthUrl = `https://appleid.apple.com/auth/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=${responseType}&response_mode=${responseMode}&scope=${scope}`;
    
    // Redirect to Apple's authentication page
    window.location.href = appleAuthUrl;
  };

  return (
    <div className="apple-login-container">
      <button 
        className="apple-login-button"
        onClick={handleAppleLogin}
        style={{
          backgroundColor: '#000',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          padding: '10px 20px',
          fontSize: '16px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          maxWidth: '300px',
          margin: '0 auto'
        }}
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="white" 
          style={{ marginRight: '10px' }}
        >
          <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.78 1.18-.19 2.31-.89 3.57-.84 1.51.18 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.1zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.31 2.46-2.01 4.42-3.74 4.25z"/>
        </svg>
        Sign in with Apple
      </button>
    </div>
  );
};

export default AppleLoginOnly; 